// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}
.card-body {
  padding: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/area-chart/area-chart.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf","sourcesContent":[":host {\n  display: block;\n}\n.card-body {\n  padding: 1rem;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
